
export const Roles = [
    { name: 'Администратор', key: 'admin' },
    { name: 'Архиадминистратор', key: 'manager' },
    { name: 'Пользователь', key: 'user' },
]
